import React from 'react';

import PropTypes from 'prop-types';

import './NetworkConnectionSubText.scss';

export const NetworkConnectionSubText = ({
  text,
  textEmail,
  textAfterEmail,
  textActionLink,
  textAction,
}) => {
  if (!text) {
    return null;
  }

  return (
    <div className="networkConnectionSubText">
      <span>{text}</span>
      {textEmail && (
        <span style={{ marginLeft: 3 }}>
          <a href={`mailto:${textEmail}`}>{textEmail}</a>
        </span>
      )}
      {textAction && (
        <span style={{ marginLeft: 3 }}>
          <a href={textActionLink} target="_blank" rel="noreferrer">
            {textAction}
          </a>
        </span>
      )}
      {textAfterEmail && <span>{textAfterEmail}</span>}
    </div>
  );
};

NetworkConnectionSubText.propTypes = {
  text: PropTypes.string,
  textEmail: PropTypes.string,
  textAfterEmail: PropTypes.string,
  textActionLink: PropTypes.string,
  textAction: PropTypes.string,
};

NetworkConnectionSubText.defaultProps = {
  text: '',
  textEmail: '',
  textAfterEmail: '',
  textActionLink: '',
  textAction: '',
};
